import React, { useRef, useEffect, useState } from 'react'
import { fetchdata, addfeed } from '../reduxactions/fundmanagersactions/AddFeedbackAction';
import { Card } from 'primereact/card'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { useNavigate } from 'react-router-dom';
import { Panel } from 'primereact/panel';
import { GFNButton } from '../ui';
import { InputTextarea } from 'primereact/inputtextarea';

export const FunAddFeedbacks = () => {
    const navigate = useNavigate();

    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('');

    const feedoptions = [
        { labels: 'Donor', value: 'donor' },
        { labels: 'Organization', value: 'organization' },

    ];

    const feedlist = [

        { "value": "excellent", "label": "Excellent" },
        { "value": "verygood", "label": "Very Good" },
        { "value": "good", "label": "Good" },
        { "value": "average", "label": "Average" },
        { "value": "poor", "label": "Poor" }

    ]


    const dispatch = useDispatch()

    const [nameId, setNameId] = useState('donor');
    useEffect(() => {
        if (nameId !== '') {
            selectName();
        }
    }, [nameId]);
    const selectName = async () => {
        console.log("nameId:", nameId)
        try {
            await dispatch(fetchdata(uid, nameId) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }
    //To assign data 
    const [assignData, setassignData] = useState({
        id: '',
    });
    const viewupload = (rowData: any) => {
        setassignData({
            id: rowData.id,
        });

        setfield(true);
    };

    const [feedbacktype, setSelectedfeed] = useState('');
    const [description, setDesc] = useState('')
    const data = useSelector((state: RootState) => state.fmaddfeedback.data)
    const dataget = useSelector((state: RootState) => state.fmaddfeedback.dataview)
    const datasmsg = useSelector((state: RootState) => state.fmaddfeedback.dataview)
    const toast = useRef(datasmsg);



    const save = async () => {
        try {
            const { id } = assignData;
            await dispatch(addfeed(uid, nameId, description, feedbacktype, id) as any);
            toast.current.show({ severity: 'success', summary: 'Success', detail: datasmsg, life: 3000 })
            setfield(false);


        } catch (error) {

        }
        setTimeout(() => {
            const url = `/ffeedback`;
            navigate(url);
        }, 2000);

    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/addfmfeedbacks.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        {/* <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">
                                    <div className="col-9">
                                        <h1>Add Feedback </h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Add Feedback</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel>
                            <div className='grid'>
                                <div className='col-12'>
                                    <div className='col-4'>
                                        <h3 > Type</h3>
                                    </div>
                                    <div className='col-4'>
                                        <span className="p-float-label">
                                            <Dropdown data-testid="type-select" optionValue="value" value={nameId} className="w-full mb-3" onChange={(e) => { setNameId(e.value); selectName(); }} options={feedoptions} optionLabel="labels" placeholder="Select a Type of Role" />
                                        </span>
                                    </div>

                                    <div className="card flex flex-wrap justify-content-end my-2">
                                        <span className="p-input-icon-left">
                                            <i className="pi pi-search ml-2" />

                                            <InputText
                                                className="app-search-input"
                                                value={globalFilter}
                                                onChange={(e) => setGlobalFilter(e.target.value)}
                                                placeholder="Global Search"
                                            />
                                        </span>
                                    </div>
                                    <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                        <Column field="name" sortable header="Name"></Column>
                                        <Column field="email" sortable header="Email"></Column>
                                        <Column field="mobile" sortable header="Phone No."></Column>
                                        <Column header="Option" body={(rowData, { rowIndex }) => (
                                            <div>
                                                {/* <Button data-testid={`add-modal-btn-${rowIndex}`} className='mr-1' severity="info" icon="pi pi-plus" rounded outlined onClick={() => viewupload(rowData)} /> */}
                                                <GFNButton data-testid={`add-modal-btn-${rowIndex}`} buttonType="secondary" icon="pi pi-plus" rounded outlined onClick={() => viewupload(rowData)} />
                                            </div>
                                        )}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </Panel>
                        <Dialog
                            header="Add Feedback"
                            style={{ width: "35vw" }}
                            breakpoints={{ "960px": "60vw", "640px": "95vw" }}
                            data-testid="add-feedback-dialog"
                            visible={acceptfield}
                            onHide={cancelfield}
                            className="border-round-3xl"
                        >

                            <div className="p-3">

                                {/* Header Section */}
                                <div className="flex align-items-center mb-4">

                                    <div
                                        className="flex align-items-center justify-content-center border-circle shadow-2"
                                        style={{
                                            width: "65px",
                                            height: "65px",
                                            background: "#e0f2fe"
                                        }}
                                    >
                                        <i className="pi pi-comments text-3xl text-blue-500"></i>
                                    </div>

                                    <div className="ml-3">
                                        <h2 className="m-0 text-900">
                                            Feedback Details
                                        </h2>

                                        <p className="m-0 text-600">
                                            Share your valuable feedback
                                        </p>
                                    </div>

                                </div>

                                {/* Form Card */}
                                <div className="surface-50 border-1 border-200 border-round-2xl p-4">

                                    {/* Feedback Type */}
                                    <div className="field mb-4">

                                        <label
                                            htmlFor="feedbacktype"
                                            className="block text-800 font-semibold mb-2"
                                        >
                                            Feedback Type
                                        </label>

                                        <Dropdown
                                            optionValue="feedbacktypes"
                                            value={feedbacktype}
                                            data-testid="add-feedback-input"
                                            onChange={(e) => setSelectedfeed(e.value)}
                                            options={feedlist}
                                            optionLabel="feedback"
                                            placeholder="Select Feedback Type"
                                            className="w-full"
                                        />

                                    </div>

                                    {/* Description */}
                                    <div className="field">

                                        <label
                                            htmlFor="description"
                                            className="block text-800 font-semibold mb-2"
                                        >
                                            Description
                                        </label>

                                        <InputTextarea
                                            id="description"
                                            rows={5}
                                            autoResize
                                            className="w-full"
                                            data-testid="add-desc-input"
                                            name="description"
                                            placeholder="Enter your feedback description..."
                                            onChange={(e) => setDesc(e.target.value)}
                                        />

                                    </div>

                                </div>

                                {/* Footer Buttons */}
                                <div className="flex justify-content-end gap-2 mt-4">

                                    <Button
                                        label="Close"
                                        icon="pi pi-times"
                                        onClick={cancelfield}
                                        data-testid="add-close-btn"
                                        className="p-button-secondary"
                                    />

                                    <Button
                                        severity="info"
                                        label="Save"
                                        icon="pi pi-check"
                                        onClick={save}
                                        data-testid="add-save-btn"
                                        className="p-button-raised"
                                    />

                                </div>

                            </div>

                        </Dialog>
                        <Toast ref={toast} >
                            <Message severity="success" content={datasmsg} />
                        </Toast>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default FunAddFeedbacks